const isBrowser = typeof window !== "undefined";
const isLocalhost =
  isBrowser &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  (isLocalhost ? "https://uptask.visiontrek.io" : "");

export const API_BASE_URL = `${API_ORIGIN}/api`;
export const FILE_BASE_URL = API_ORIGIN;
